import React from 'react';
import { ArtifactoryMarkdown } from '../artifactory/ArtifactoryMarkdown';
import { useTheme } from '../../contexts/ThemeContext';

interface SkillPreviewProps {
  content: string;
  mode?: 'preview' | 'raw';
}

// Languages reliably registered in rehype-highlight's default bundle.
// Anything outside this set gets replaced with 'text' to avoid crashes.
const SAFE_LANGS = new Set([
  'javascript', 'js', 'typescript', 'ts', 'jsx', 'tsx',
  'python', 'py', 'ruby', 'rb', 'java', 'kotlin', 'swift',
  'c', 'cpp', 'cs', 'go', 'rust', 'php',
  'html', 'xml', 'css', 'scss', 'less',
  'json', 'yaml', 'toml', 'markdown', 'md',
  'bash', 'sh', 'shell', 'zsh',
  'sql', 'graphql', 'dockerfile',
  'text', 'plaintext', 'plain',
]);

function sanitizeCodeFences(content: string): string {
  return content.replace(/^```(\w+)/gm, (match, lang) => {
    return SAFE_LANGS.has(lang.toLowerCase()) ? match : '```text';
  });
}

export const SkillPreview: React.FC<SkillPreviewProps> = ({ content, mode = 'preview' }) => {
  const { darkMode } = useTheme();

  if (mode === 'raw') {
    return (
      <pre className={`p-4 rounded-md text-xs font-mono overflow-auto whitespace-pre-wrap ${
        darkMode ? 'bg-gray-900 text-gray-300' : 'bg-gray-50 text-gray-800'
      }`}>
        {content}
      </pre>
    );
  }

  return (
    <div className={`p-4 rounded-md ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <ArtifactoryMarkdown content={sanitizeCodeFences(content)} size="medium" />
    </div>
  );
};
